import { Trans } from "@lingui/react/macro";
import { Box, Container, Link as MuiLink, Stack, Typography } from "@mui/material";
import AppLayout from "@/components/AppLayout";

export default function PrivacyPolicy() {
  return (
    <AppLayout contentMaxWidth="md">
      <Container maxWidth="md" sx={{ py: { xs: 3, md: 4 }, px: { xs: 2, md: 3 } }}>
        <Typography variant="h2" gutterBottom sx={{ mb: 3 }}>
          <Trans>Privacy Policy</Trans>
        </Typography>
        <Stack spacing={1.5}>
          <Typography variant="body1">
            <strong>
              <Trans>I. General information and legal basis</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              The following statement informs you about what kind of personal data is collected for
              what purpose on this website by us as the responsible party and to what extent this
              data is made available to third parties.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>1. Controller:</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              CampNerd GmbH & Co KG
              <br />
              Spandauer Burgwall 22a
              <br />
              13581 Berlin
              <br />
              Telephone: 030 - 33 77 83 20
              <br />
              Email: <MuiLink href="mailto:office@campnerd.camp">office@campnerd.camp</MuiLink>
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>2. Legal bases of the processing</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              The processing of personal data requires a legal basis, which we would like to present
              to you below. For processing of personal data for which we obtain the consent of the
              data subject, Article 6(1)(a) of the EU General Data Protection Regulation (GDPR)
              serves as the legal basis. When processing personal data that is necessary for the
              performance of a contract to which the data subject is a party, Article 6(1)(b) DSGVO
              serves as the legal basis. This also includes processing operations that are necessary
              for the performance of pre-contractual measures. If processing of personal data is
              necessary for compliance with a legal obligation to which our company is subject,
              Article 6 (1) c DSGVO serves as the legal basis. If processing is necessary to protect
              a legitimate interest of our company or a third party and if the interests,
              fundamental rights and freedoms of the data subject do not override the former
              interest, Article 6(1)(f) DSGVO serves as the legal basis for the processing. The
              legitimate interest of our company lies in the performance of our business activities
              as well as in the analysis, optimization and maintenance of the security of our online
              offer.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>II. Log files, hosting</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              In the server statistics, data is automatically stored that the browser transmits to
              us as part of our legitimate interest in analysis and for security reasons (so-called
              "log files").
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>In detail, these are the following data:</Trans>
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 3 }}>
            <Typography component="li" variant="body1">
              <Trans>Language and version of the browser software</Trans>
            </Typography>
            <Typography component="li" variant="body1">
              <Trans>Operating system used and its interface</Trans>
            </Typography>
            <Typography component="li" variant="body1">
              <Trans>Referrer URL (the previously visited page)</Trans>
            </Typography>
            <Typography component="li" variant="body1">
              <Trans>Host name of the accessing computer (IP address)</Trans>
            </Typography>
            <Typography component="li" variant="body1">
              <Trans>Date and time of the server request</Trans>
            </Typography>
            <Typography component="li" variant="body1">
              <Trans>Time zone difference from Greenwich Mean Time (GMT)</Trans>
            </Typography>
            <Typography component="li" variant="body1">
              <Trans>Content of the request (concrete page)</Trans>
            </Typography>
            <Typography component="li" variant="body1">
              <Trans>Data volume transferred</Trans>
            </Typography>
            <Typography component="li" variant="body1">
              <Trans>Access status/ HTTP status code.</Trans>
            </Typography>
          </Box>
          <Typography variant="body1">
            <Trans>
              As a rule, we cannot assign this data to specific persons. A combination of this data
              with other data sources is not made. The data is also deleted within 7 days after a
              statistical evaluation. Data whose further retention is required for evidentiary
              purposes is exempt from deletion until the respective incident has been finally
              clarified.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              We make use of hosting services. These serve to provide infrastructure and platform
              services, computing capacity, storage space and database services, security services
              and technical maintenance services to maintain the operation of this online offer.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              In doing so, we or our hosting provider process inventory data, contact data, content
              data, contract data, usage data, meta data and communication data of customers,
              interested parties and visitors of this online offer on the basis of our legitimate
              interests in an efficient and secure provision of this online offer.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>III. Contractual processing</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              The personal data provided by you for contractual purposes in the case of e.g.
              requests for quotations, such as name, address or e-mail address, will only be used
              internally to answer your inquiries, process your orders or provide you with access to
              certain contractual information.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>IV. Contact</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              When you contact us, e.g. by e-mail, your details will be stored by us in order to
              answer your questions. A transfer to third parties does not take place in principle,
              unless applicable data protection regulations justify a transfer or we are legally
              obliged to do so. You can revoke your consent at any time with effect for the future.
              In the event of revocation, your data will be deleted immediately, unless there is a
              legal exception for further processing. Your data will otherwise be deleted when we
              have processed your request or the purpose of storage has ceased to apply and there
              are no other legal exceptions to the contrary.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>V. Cookies</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              This site uses cookies. Cookies are small text files that are stored on your computer
              and through which the entity that sets the cookie receives certain information. They
              are used to make the Internet offer more user-friendly and effective or/and to
              facilitate your navigation on our website. We set cookies that are not absolutely
              necessary only with your consent. You can revoke this consent at any time for future
              use.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              Consent is voluntary and you can also use our website without accepting cookies. You
              can also configure your browser settings according to your wishes and, for example,
              refuse to accept third party cookies or all cookies or delete cookies that have
              already been stored. If you do not accept cookies, please note that in this case our
              offer may not work properly. If we do not provide any other information on the
              individual topics mentioned in this data protection declaration or in the cookie
              banner, the lifetime of the cookies refers to 24 months. You can find out which
              function on our website sets cookies below under the individual functions.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>VI. Registration</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              Our website offers a registration option. The personal data entered during
              registration will be transmitted to the controller. The data is stored exclusively for
              internal use by us. During registration, the user's IP address and the date and time
              of registration are stored. This serves to prevent misuse of the services. The data
              will not be passed on to third parties. An exception exists if there is a legal
              obligation to pass on the data. The registration of data is necessary for the
              provision of content or services. Registered persons have the possibility to have the
              stored data deleted or modified at any time. The person concerned can obtain
              information about the personal data stored about him at any time.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>VII. Our presences in social media</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              You can find us under online presences within social networks and platforms. We would
              like to use these presences to communicate with our customers, interested parties and
              users who are active there and to inform them in this way about our services and our
              company. The processing of the personal data of the users active there is based on our
              legitimate interests in communicating and providing information to and with the users.
              Insofar as consent to data processing has been given by users within the framework of
              the respective social platform, processing is carried out on the basis of this
              consent.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              If you visit one of our social media sites, we are jointly responsible with the
              operator of the social platform for the data processing operations triggered during
              this visit. In principle, you can assert your rights (information, correction,
              deletion, restriction of processing, data portability and complaint, see the following
              point "Rights of the data subject") both against us and against the operator of the
              respective social platform. We would like to point out that despite the joint
              responsibility, we do not have full influence on the data processing operations of the
              social platform and, if necessary, forward the rights request to the respective
              operator for better processing of the data subject rights. Our options are basically
              based on the corporate policy of the respective provider.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              You can find our storage details below. We have no influence on the storage period of
              your data, which is stored by the operator of the social platform for its own
              purposes. For details, please contact the operators of the social networks directly
              (e.g. in their privacy policy, see below). Depending on the following named social
              platform, user data processing may also occur outside the area of the European Union.
              EU standard contractual clauses have been agreed with the US companies, so that we
              have taken possible measures to ensure European data protection law. User data is
              usually processed by the platforms for market research and advertising purposes. For
              example, usage profiles can be created from the usage behavior and resulting interests
              of the users. The usage profiles can in turn be used, for example, to place
              advertisements within and outside the platforms that presumably correspond to the
              interests of the users. For this purpose, cookies are usually stored on the users'
              computers, in which the usage behavior and the interests of the users are stored. Data
              can also be stored in the usage profiles regardless of the devices used by the users.
              This occurs in particular if the users are members of the respective platforms and are
              logged in to them. For a detailed description of the respective processing and the
              objection options, we refer to the information of the providers linked below.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              <strong>- LinkedIn</strong>
              <br />
              (LinkedIn Ireland Unlimited Company Wilton Place, Dublin 2, Ireland) Privacy Policy{" "}
              <MuiLink
                href="https://www.linkedin.com/legal/privacy-policy"
                target="_blank"
                rel="noreferrer"
              >
                https://www.linkedin.com/legal/privacy-policy
              </MuiLink>{" "}
              Opt-Out:{" "}
              <MuiLink
                href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
                target="_blank"
                rel="noreferrer"
              >
                https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out
              </MuiLink>
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>
                VIII. Disclosure of data to third parties: General and contractual purpose
              </Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              We pass on data to third parties if this is necessary for the fulfillment of the
              contract and / or we are legally obligated and / or authorized to do so in individual
              cases.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>
                IX. Disclosure of data to third parties: tools for the economic operation of the
                website
              </Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              In part, we use external service providers within the scope of your consent or our
              legitimate interests with regard to analysis, optimization and economic operation of
              the online offer. If you have given your consent for tools that are not necessary for
              the operation of the website, you can also have these settings changed again at any
              time. We list our service providers below.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              If your data is to be used for other purposes, we will inform you in advance and only
              use the data if you have previously given your express further consent.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>1. Google</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              Within the scope of your consent, we use services for the optimization and economic
              operation of our online offer for which Google Ireland Limited, Gordon House, Barrow
              Street, Dublin 4, Ireland ("Google") is responsible. EU standard contractual clauses
              have been agreed with Google so that we have taken possible measures to ensure
              compliance with European data protection law.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>a. Google Analytics</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              This website uses Google Analytics as a web analytics service based on your consent.
              Google Analytics uses "cookies", which are text files placed on your computer, to help
              the website analyze how users use the site. The information generated by the cookie
              about your use of this website (including your IP address) will be transmitted to and
              stored by Google on servers in the United States.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              We would like to point out that this website uses Google Analytics with IP
              anonymization and therefore IP addresses are shortened by Google in member states
              within the European Union or in other contracting states of the Agreement on the
              European Economic Area before transmission in order to exclude a direct reference to
              persons. Only in exceptional cases will the full IP address be transmitted to a Google
              server in the USA and shortened there. On behalf of the provider, Google will use this
              information for the purpose of evaluating your use of the website, compiling reports
              on website activity for website operators and providing other services relating to
              website activity and internet usage. Google may also transfer this information to
              third parties where required to do so by law, or where such third parties process the
              information on Google's behalf. To our knowledge, Google will not associate your IP
              address with any other data held by Google. You can revoke your consent at any time
              with future effect by accessing the cookie settings of our website and changing your
              selection there. The legality of the processing carried out on the basis of the
              consent until the revocation remains unaffected.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              You may also refuse the use of cookies by selecting the appropriate settings on your
              browser, however please note that if you do this you may not be able to use the full
              functionality of this website. You can also object to the collection and storage of
              data by Google for the respective end device at any time with effect for the future in
              connection with the use under this link:{" "}
              <MuiLink
                href="http://tools.google.com/dlpage/gaoptout?hl=de"
                target="_blank"
                rel="noreferrer"
              >
                http://tools.google.com/dlpage/gaoptout?hl=de
              </MuiLink>
              .
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              For the purpose and scope of the data collection and the further processing and use of
              the data by Google, as well as your rights in this regard and setting options for
              protecting your privacy, please refer to Google's privacy policy at{" "}
              <MuiLink
                href="https://marketingplatform.google.com/about/analytics/terms/de/"
                target="_blank"
                rel="noreferrer"
              >
                https://marketingplatform.google.com/about/analytics/terms/de/
              </MuiLink>{" "}
              and at{" "}
              <MuiLink href="https://policies.google.com/" target="_blank" rel="noreferrer">
                policies.google.com
              </MuiLink>
              .
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>X. Data storage outside the EU/EEA</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              As can be seen from the individual tool descriptions above, we use tools from US
              third-party providers. Insofar as this is necessary for the notified purposes, it may
              happen that your IP address is processed in this course outside the European Economic
              Area, where a level of data protection corresponding to the European standard is not
              consistently ensured and confirmed (for example, by appropriate guarantee within the
              meaning of Art. 46 DS-GVO or an adequacy decision of the European Commission).
              Therefore, it cannot be ruled out in particular that security authorities in a third
              country may gain access to your IP address without you being able to take legally
              effective action against them.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              The transfer of the IP address to these third-party providers takes place in
              accordance with Art. 49 (1) lit. a DSGVO on the basis of your consent expressly given
              for this purpose in the consent banner. This consent is voluntary. You can revoke it
              at any time with effect for the future. You will not suffer any disadvantages as a
              result.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              In the opinion of some US third-party providers, a level of protection corresponding
              to the European standard is already guaranteed due to the conclusion of so-called
              standard contractual clauses as well as additional measures taken in the sense of the
              Schrems II case law. However, since the suitability of such measures to ensure a
              sufficient level of data protection is disputed, we have decided to transfer your IP
              address only with your consent.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>XI. Rights of the data subject</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              You have a right to information about the personal data stored by us about you.
              According to the legal provisions, you also have the right to correct incorrect data,
              blocking, data portability and deletion of your personal data. To do this, send us an
              e-mail with the subject "Data protection".
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              You also have the right to lodge a complaint with a data protection supervisory
              authority if you believe that processing of personal data relating to you is in breach
              of the law.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              If you have given your consent, you have the right to revoke your consent at any time.
              This does not affect the lawfulness of the processing carried out on the basis of the
              consent until the revocation.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              You may object to the future processing of your personal data in accordance with the
              legal requirements at any time. The objection can be made in particular against the
              processing for purposes of direct advertising.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>XII. Storage period of the personal data</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              If we have not provided storage information on the specific points, the following
              applies: We store personal data for the duration of the respective statutory retention
              period or as long as the purpose of the collection exists. After expiry of the
              retention period, the data is routinely deleted, unless it is necessary for the
              initiation or performance of a contract. If user data is not deleted because it is
              required for other and legally permissible purposes, its processing will be restricted
              as far as possible. Accordingly, the data will be blocked if possible and not
              processed for other purposes. This applies, for example, to user data that must be
              retained for reasons of commercial or tax law.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <strong>
              <Trans>XIII. Safety information</Trans>
            </strong>
          </Typography>
          <Typography variant="body1">
            <Trans>
              We make every effort to process your personal data by taking all technical and
              organizational possibilities to comply with the provisions of data protection laws and
              thus to protect this data. Our website or the communication via our website with us is
              encrypted via HTTPS.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans>
              This privacy policy was provided by the Sieling Law Firm – Specialist law firm for IT
              law.
            </Trans>
          </Typography>
        </Stack>
      </Container>
    </AppLayout>
  );
}
